<template>
  <div style="display: flex">

  </div>

</template>
<script>
  // import {BaiduMap} from '../common/Bmap.js';
  import 'echarts/map/js/china.js';
  // import 'echarts/extension/bmap/bmap.js';

  export default {
    name: 'index',
    data() {
      return {

      }
    },
    created() {

    },
    mounted() {


    },

    beforeDestroy() {

    },
    methods: {





    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Index.vue